/* Our Story — pinned quote: words rise and light up across the 220vh wrapper (scrub 0.5). */
(function () {
  function init(root) {
    if (!root || root._stQuote) return;
    root._stQuote = true;
    var D = window.Dozzee || {};
    if (D.reduce || !D.gsap) return;
    D.gsap(function (gsap, ST, Split) {
      var pt = root.querySelector('[data-pinq]');
      if (!pt) return;
      var sp = Split.create(pt, { type: 'words' });
      root._stSplit = sp;
      root._stCtx = gsap.context(function () {
        gsap.timeline({ scrollTrigger: { trigger: root, start: 'top top', end: 'bottom bottom', scrub: 0.5 } })
          .fromTo(sp.words, { opacity: 0.14, yPercent: 24 }, { opacity: 1, yPercent: 0, stagger: 0.1, ease: 'none' })
          .to({}, { duration: 0.4 });
      }, root);
    });
  }
  function destroy(root) {
    if (!root) return;
    if (root._stCtx) root._stCtx.revert();
    if (root._stSplit) { try { root._stSplit.revert(); } catch (e) {} }
    root._stCtx = null; root._stSplit = null; root._stQuote = false;
  }
  function all(scope) { (scope || document).querySelectorAll('[data-section-type="story-quote"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-section-type="story-quote"]').forEach(destroy); });
})();
